import React, { useState } from "react";
import styles from "./DynamicTable.module.css";

const DynamicTable = ({
  data,
  onVerify,
  handleLoginAsUser,
  handleCopyUserLink,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleVerifyClick = (userId) => {
    setSelectedUserId(userId);
    setShowModal(true);
  };

  const confirmVerify = () => {
    onVerify(selectedUserId);
    setShowModal(false);
    setSelectedUserId(null);
  };

  const cancelVerify = () => {
    setShowModal(false);
    setSelectedUserId(null);
  };

  function convertUTCToIST(utcTimeString) {
    const isoString = `1970-01-01T${utcTimeString.replace("Z", "")}Z`;
    const date = new Date(isoString);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    const pad = (n) => n.toString().padStart(2, "0");
    const hours = pad(istDate.getUTCHours());
    const minutes = pad(istDate.getUTCMinutes());
    const seconds = pad(istDate.getUTCSeconds());
    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.headerCell}>ID</th>
            <th className={styles.headerCell}>First Name</th>
            <th className={styles.headerCell}>Last Name</th>
            <th className={styles.headerCell}>Email</th>
            <th className={styles.headerCell}>Plan</th>
            <th className={styles.headerCell}>Company</th>
            <th className={styles.headerCell}>Email Verified</th>
            <th className={styles.headerCell}>Created Date</th>
            <th className={styles.headerCell}>Open User</th>
            <th className={styles.headerCell}>Copy Link</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((row, idx) => (
            <tr key={idx} className={styles.dataRow}>
              <td className={styles.dataCell}>{row.id ?? "-"}</td>
              <td className={styles.dataCell}>{row.firstName ?? "-"}</td>
              <td className={styles.dataCell}>{row.lastName ?? "-"}</td>
              <td className={styles.dataCell}>{row.email ?? "-"}</td>
              <td className={styles.dataCell}>{row.plan ?? "-"}</td>
              <td className={styles.dataCell}>{row.company ?? "-"}</td>
              <td className={styles.dataCell}>
                {row.email_verified === "1" ? (
                  "True"
                ) : (
                  <button
                    className={styles.verifyBtn}
                    onClick={() => handleVerifyClick(row.id)}
                  >
                    Verify
                  </button>
                )}
              </td>
              <td className={styles.dataCell}>
                {row.createdAt.split("T")[0].split("-").reverse().join("-")}
                {" | "}
                {convertUTCToIST(row.createdAt.split("T")[1])}
              </td>
              <td className={styles.dataCell}>
                <button onClick={() => handleLoginAsUser(row)}>
                  Open User
                </button>
              </td>
              <td className={styles.dataCell}>
                <button onClick={() => handleCopyUserLink(row)}>
                  Copy Link
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Confirmation Modal */}
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <p>Are you sure you want to verify this user?</p>
            <div className={styles.modalButtons}>
              <button className={styles.confirmBtn} onClick={confirmVerify}>
                Verify
              </button>
              <button className={styles.cancelBtn} onClick={cancelVerify}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicTable;
